<template>
  <div>
    <b-form-group
        v-if="!inputWithHints"
        :state="formField == null || formField.isValid"
    >
      <span v-if="!onlyInputVisible">
        <img v-if="canTranslate" :src="'https://silkplm.com/wp-content/uploads/flags/' + typingLanguage + '.webp'" style="width: 15px; height: 12px">

        <b-button v-if="canTranslate" variant="plm-action" :data-test-path="'translate-' + label" @click="translateFromDef" size="sm"
                  style="width: 22px;
                  height: 18px;
                  padding-left: 1px;
                  padding-top: 0px;">
          <font-awesome-icon icon="language" transform="shrink-3 up-2"></font-awesome-icon>
        </b-button>
        <slot name="label">
        <span class="d-inline-flex align-items-center gap-2">
            {{ label }}
           <HintEditor
               ref="hint"
               :editor-mode="editorMode"
               :field-config="fieldConfig"
               :help-message="helpMessage"
               :help-title="helpTitle"
               :validated-field="formField"
           >
          </HintEditor>
            <small v-if="formField && labelTip" class="form-text text-warning font-weight-bold pl-2">
              {{ labelTip || '&nbsp;' }}
            </small>
          </span>

        </slot>
        <span v-if="hasLink" class="pl-0">
          <b-link variant="link" @click="goTo()" class="pr-1">
            <font-awesome-icon icon="link-horizontal" transform="shrink-4"></font-awesome-icon>
          </b-link>
        </span>
        <span v-if="fieldConfig && fieldConfig.readOnly" class="text-primary">
          <font-awesome-icon icon="lock" style="height: 12px; margin-left: 2px; padding-bottom: 1px;"></font-awesome-icon>
        </span>
        <span v-if="extraTip" class="text-primary" @click="showTooltip">
          <font-awesome-icon icon="circle-question"
                             style="height: 16px; color: orange;"></font-awesome-icon>
        </span>
      </span>

      <b-container>
        <b-row>
          <b-col class="p-0">
            <div class="input-group">
              <slot name="left-slot"></slot>
              <div class="input-group-prepend" v-if="iconArr && showLeftIcon">
                <span class="input-group-text"><font-awesome-icon :icon="iconArr"/></span>
              </div>
              <div class="input-group-prepend" v-if="fieldType && formField.value && readOnly">
                <span class="input-group-text">
                  <a :href="fieldType + formField.value">
                    <font-awesome-icon v-if="iconArr" :icon="iconArr"/>
                  </a>
                </span>
              </div>

              <div class="form-control grey-label notifications-list readonly-input"
                   v-if="readOnly"
              >
                <div>{{
                    (fieldConfig !== null && formField.value !== null && fieldConfig.inputType === 'password') ? '•'.repeat(formField.value.length) : formField.value
                  }}
                </div>
              </div>
              <b-form-input style="padding-right: 15px"
                            :class="readOnlyText ? 'form-control grey-label notifications-list readonly-input' : ''"
                            v-else
                            v-on:keydown.enter="enterTrigger"
                            v-on:keydown.esc="escTrigger"
                            @focusin="focusIn"
                            @focusout="focusOut"
                            ref="input"
                            v-model="formField.value"
                            :type="(fieldConfig !== null && formField.value !== null && fieldConfig.inputType !== 'text') ? fieldConfig.inputType : type"
                            :placeholder="placeholder"
                            :autocomplete="autocomplete"
                            :readonly="readOnlyText"
              >
              </b-form-input>

              <div v-if="showRightIcon && formField.value" style="position: relative; width: 0; height: 0; z-index: 3">
                <div v-if="icon"
                     :style="icon2 || icon3 ? 'position: absolute; right: 42px' : 'position: absolute; right: 0px'">
                  <div style="width: 42px; min-width: 42px;" class="input-group-prepend">
                    <b-button style="height: 38px" :disabled="!formField.isValid  || !formField.isChecked"
                              @click="emitDialog" class="input-group-text">
                      <font-awesome-icon :icon="icon" style="color: blue"/>
                    </b-button>
                  </div>
                </div>
                <div v-if="formField.isChecked && icon2 || icon3" style="position: absolute; right: 0; z-index: 3;">
                  <div class="input-group-prepend" style="width: 42px; min-width: 42px;">
                <span style="height: 38px; width: 100%;  padding-left: 13px;" class="input-group-text">
                  <font-awesome-icon v-if="formField.isValid" :icon="icon2" style="color: green"/>
                  <font-awesome-icon v-else-if="!formField.isValid" :icon="icon3" style="color: red"/>
                </span>
                  </div>
                </div>
              </div>
              <slot name="right-slot"></slot>
            </div>

          </b-col>
        </b-row>
        <b-row style="padding-top: 3px" v-if="!onlyInputVisible">
          <b-col class="p-0">
            <small data-test-path="" v-if="formField.isValid && !formField.hintMessage && hint" style="margin-top: 2px"
                   class="form-text text-muted"> {{ hint }}
            </small>
            <small v-else-if="!formField.isValid" style="margin-top: 2px; margin-left: 10px;"
                   class="form-text text-danger font-weight-bold">{{ formField.errorMessage || '&nbsp;' }}
            </small>
            <small v-if="formField.hintMessage" style="margin-top: 2px; margin-left: 10px;"
                   class="form-text text-warning font-weight-bold">{{ formField.hintMessage || '&nbsp;' }}
            </small>
            <small
                v-else-if="mode !== 'NEW' && hasChangedValue && (interfaceTranslationsEnabled || customerTranslationsEnabled) && formField.isValid"
                class="form-text text-warning font-weight-bold"
                data-test-path="translations-label-info">{{ translationLabelInfo || '&nbsp;' }}
            </small>
          </b-col>
          <b-col style="height: 28px;" class="pt-1 pl-0 pr-0 col-auto">
            <transition name="fade">
              <b-spinner
                  v-if="formField.validationInProgress"
                  variant="plm-primary"
                  small
                  label="Spinning">
              </b-spinner>
            </transition>
          </b-col>
        </b-row>
      </b-container>
    </b-form-group>
    <b-form-group
        ref="hints"
        v-else
        style="min-height: 110px"
        :label="onlyInputVisible ? '' : label"
        class="mb-0"
    >
      <b-container class="pl-0 pr-0">
        <b-row no-gutters>
          <div class="grey-label form-control"
               v-if="readOnly"
          >{{ searchInput }}
          </div>
          <b-col v-else>
            <b-form-input
                autocomplete="off"
                :placeholder="placeholder"
                v-model="searchInput"
                @keydown="searchChanged"
                @focusout="hideSearch($event, !searchInputId)"
            ></b-form-input>
            <div style="position: absolute; z-index: 10000; width: 100%"
                 :style="realBottom < 316 ? 'bottom: 40px' : 'top: 40px'"
                 :class="showSearchList ? '' : 'd-none'">
              <div v-if="actionsEmpty">
                <span class="list-group-item list-group-item-action"> <i> No results found </i></span>
              </div>
              <div class="list-group border-bottom border-top" style="max-height: 231px; overflow: auto;"
                   v-else>
                <a v-for="action in actions"
                   href="#" class="list-group-item list-group-item-action"
                   :data-action-id="action[actionId]"
                >
                  <span class="pl-1" v-html="action[actionName]"></span></a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-form-group>
  </div>
</template>


<script>
import ValidatedField from "@/validation/ValidatedField";
import {parseIconName} from "@/FontAwesomeSetup";
import FormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig";
import HintEditor from "@/components/inputs/controls/HintEditor";
import FormsActions from "@/components/forms/FormsActions";
import {
  findFieldValueFromCompanyCompanyConfigurationFormField
} from "@/components/forms/customizations/plm/EntityEditFormService";
import RegionSmIcon from "@/components/RegionSmIcon.vue";
import Rpc from "@/Rpc";
import FormModel from "@/components/forms/FormModel";
import {
  detectDBLanguage,
  detectInputTypingLanguage, getValueForTypingInput,
  isCustomerTranslationEnabledOnField,
  isInterfaceTranslationEnabledOnField, prepareDialogInput, saveFieldsTranslationsFromDialog, showTranslationActivity
} from "@/utils/TranslationDispatcher";
import {cloneClassInstance} from "@/utils/Objects";
import DialogManager from "@/utils/DialogManager";

export default {
  name: "ReachInput",

  components: {RegionSmIcon, HintEditor},

  created() {
    this.loadList = null;
    this.pendingTimer = null;
    this.lastQuery = null;

    if (this.fieldType) {
      if (this.fieldType === "mailto:") {
        this.iconArr = "envelope"
      } else if (this.fieldType === "tel:") {
        this.iconArr = "phone-alt";
      }
    }
  },

  async mounted() {
    if (this.initialFocus) {
      let canInitialFocus = true;
      if (this.formField?.validatedForm?.formConfig?.onlyEmbedded) {
        canInitialFocus = false;
      }
      if (canInitialFocus) {
        setTimeout(() => this.afterMounted(), 200);
      }
    }
    this.assignLabelTip();
    this.assignExtraTip();
    setTimeout(() => {
      this.originalVal = this.formField.value;
    });

    this.interfaceTranslationsEnabled = isInterfaceTranslationEnabledOnField(this.formField);
    this.customerTranslationsEnabled = isCustomerTranslationEnabledOnField(this.formField);
    this.canTranslate = this.customerTranslationsEnabled || this.interfaceTranslationsEnabled;

    this.typingLanguage = detectInputTypingLanguage(this.formField);
    this.fieldLanguageDb = detectDBLanguage(this.formField);
  },

  methods: {
    focusIn() {
    },

    async handleOpenFromGrid() {
      let result = await showTranslationActivity(prepareDialogInput(this.formField, this.openFromGrid));
      await saveFieldsTranslationsFromDialog(result, this.formField);
    },

    async handleOpenFromForm() {
      let result = await showTranslationActivity(prepareDialogInput(this.formField, this.openFromGrid));
      if(!result){
        return;
      }
      if (!result["translations"] || this.mode !== 'EDIT') {
        return;
      }
      let translation = await saveFieldsTranslationsFromDialog(result, this.formField);
      this.formField.value = getValueForTypingInput(translation, this.formField);
    },

    async translateFromDef() {
      if (this.gridEditor) {
        this.gridEditor.close()
      }
      if (this.openFromGrid) {
        await this.handleOpenFromGrid();
      } else {
        await this.handleOpenFromForm();
      }
    },

    focusOut() {
        this.formField?.validate();
    },

    afterMounted() {
      if (!this.readOnly) {
        if (this.$refs?.input) {
          this.$refs.input.focus();
        }
      }
    },

    findContainer() {
      let node = this.$el;
      while (node && node !== document.body) {
        let hasHorizontalScrollbar = node.scrollWidth > node.clientWidth;
        let hasScrollableStyle = node.style["overflow-y"] && node.style["overflow-y"] === 'auto';

        if (hasScrollableStyle || hasHorizontalScrollbar) {
          return node;
        }
        node = node.parentNode;
      }
      return document.body;
    },

    countOffset() {
      let parent = this.findContainer();
      let parentOffset = parent.getBoundingClientRect();

      let offsets = this.$refs.hints.$el.getBoundingClientRect();
      let top = offsets.top;
      this.realBottom = parentOffset.bottom - top;
    },

    enterTrigger(event) {
      this.$emit('enter');
    },

    escTrigger(event) {
      this.$emit('esc');
    },


    //input with hints
    async execute(actionId) {
      if (actionId) {
        let hint = _.find(this.actions, [this.actionId, actionId]);
        if (hint) {
          this.$emit('selected-item', hint);
          this.searchInput = hint[this.actionName];
          this.searchInputId = hint[this.actionId];
        }
      }
    },

    searchChanged(key) {
      if (key.code === "Enter") {
        this.executeQuery();
        return false;
      }

      this.hideSearch();
      if (this.pendingTimer) {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }

      this.pendingTimer = setTimeout(() => {
        this.executeQuery();
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }, 100);
    },

    searchClicked() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      this.executeQuery();
    },

    executeQuery(inp) {
      this.searchInputId = null;
      inp = inp || this.searchInput
      this.queryInProgress = true;
      this.lastQuery = inp
      if (this.searchInput.length < 1) {
        this.procQueryResult([]);
        return;
      }

      this.searchesInProgress += 1;
      if (this.caseIgnore) {
        let ignoreCase = (str) => {
          return str.split(" ").map((str) => str = str.charAt(0).toUpperCase() + str.substring(1).toLowerCase()).join(" ")
        };
        this.lastQuery = ignoreCase(this.lastQuery);
        inp = ignoreCase(this.lastQuery);
      }

      this.loadList?.(this.lastQuery).then((res) => {
        this.countOffset();
        this.searchesInProgress -= 1;
        if (this.lastQuery == inp) {
          this.actions = res;
          this.showSearchList = true;
          this.actionsEmpty = (res.length == 0);
        }
      }).catch(e => {
        Log.fatal("Search failed:" + JSON.stringify(e));
        this.searchesInProgress -= 1;
        this.actions = [];
        this.showSearchList = true;
        this.actionsEmpty = true;
      });
    },
    procQueryResult() {
    },


    hideSearch(event, cleanInput) {
      if (event) {
        let target = event.relatedTarget;

        if (target === this.$refs["goLink"]) {
          return;
        }
        if (target && target.dataset && target.dataset.actionId) {
          this.execute(target.dataset.actionId);
        }
      }


      setTimeout(() => {
        this.showSearchList = false;
        if (cleanInput && !this.searchInputId) {
          this.searchInput = "";
        }
      });
    },

    changeModel() {
      this.$emit('model-change', this.searchInput);
    },

    emitDialog() {
      this.$emit('show-dialog');
    },

    goTo() {
      if (this.hasLink) {
        let link = this.formField.validatedForm.originalSource.__computed_links__[this.fieldConfig.fieldName];
        FormsActions.goTo(link);
      }
    },
    refreshLinks() {
      this.hasLink = false;
      if (this.fieldConfig?.joined) {
        if (this.formField?.validatedForm?.originalSource?.__computed_links__ &&
            this.formField.validatedForm.originalSource.__computed_links__[this.fieldConfig.fieldName]) {
          let link = this.formField.validatedForm.originalSource.__computed_links__[this.fieldConfig.fieldName];

          this.hasLink = true;
          this.link = link;
        }
      }
    },
    assignLabelTip() {
      let fieldConfig = this.fieldConfig;
      if (!fieldConfig) {
        fieldConfig = this.formField.formFieldConfig;
      }
      let validatedField = this.formField;
      let formId = validatedField.validatedForm?.formConfig?.formId;
      if (formId) {
        this.labelTip = findFieldValueFromCompanyCompanyConfigurationFormField(validatedField.validatedForm?.formConfig, fieldConfig, "labelTip");
      }
    },

    async showTooltip() {
      await DialogManager.infoShort(this.fieldLabel + ' ' + $tr('extra.tip.title', 'additional tip'), this.extraTip);
    },

    assignExtraTip() {
      let fieldConfig = this.fieldConfig;
      if (!fieldConfig) {
        fieldConfig = this.formField.formFieldConfig;
      }
      let validatedField = this.formField;
      let formId = validatedField.validatedForm?.formConfig?.formId;
      if (formId) {
        this.extraTip = findFieldValueFromCompanyCompanyConfigurationFormField(validatedField.validatedForm?.formConfig, fieldConfig, "extraTip");
        this.extraTip?.replaceAll("\n", '<br />');
      }
    },
  },

  model: {
    prop: 'inputValue',
    event: 'model-change',
  },

  props: {
    enter: Function,
    esc: Function,
    selectedItem: Function,
    showDialog: Function,

    inputWithHints: {type: Boolean, default: false},
    readOnly: {type: Boolean, default: false},
    editorMode: {type: Boolean, default: false},
    helpTitle: {type: String, default: ""},
    helpMessage: {type: String, default: ""},
    htmlHelpText: {type: String, default: ""},
    fieldType: {type: String, default: ""},
    formField: {type: ValidatedField, default: null},
    fieldConfig: {type: FormFieldConfig, default: null},
    label: {type: String, default: "\u00A0"},
    placeholder: {type: String, default: ""},
    autocomplete: {type: String, default: ""},
    type: {type: String},
    hint: {type: String, default: ""},
    initialFocus: {type: Boolean, default: false},
    icon: {type: String, default: ""},
    icon2: {type: String, default: ""},
    icon3: {type: String, default: ""},
    showRightIcon: {type: Boolean, default: false},
    showLeftIcon: {type: Boolean, default: false},
    readOnlyText: {type: Boolean, default: false},

    inputValue: {type: String, default: ""},
    actionName: {type: String, default: ""},
    actionId: {type: String, default: "id"},

    heightOfCard: {type: Number, default: null},
    caseIgnore: {type: Boolean, default: false},
    openFromGrid: {default: false},
    mode: {default: null},
    parentForm: {type: FormModel},
    gridEditor: {default: null}
  },

  watch: {
    icon: function (newVal, oldVal) {
      this.iconArr = parseIconName(newVal);
    },
    searchInput: function (newVal, oldVal) {
      this.changeModel();
    },
    inputValue: function (newVal, oldVal) {
      this.searchInput = newVal;
      this.$emit("input", newVal);
    },
    "formField": function (val) {
      this.refreshLinks();
    },
    "formField.value": function (val) {
      this.refreshLinks();
      this.$emit("input", val);
      if (this.savedDbValue === undefined) {
        this.savedDbValue = val;
      }
      this.hasChangedValue = val !== this.savedDbValue;
    },
  },

  data: function () {
    let onlyInputVisible = this.formField?.__hideHints;
    return {
      onlyInputVisible,
      canTranslate: false,
      iconArr: "",
      searchInput: "",
      searchInputId: null,
      queryInProgress: false,
      showSearchList: false,
      actions: [],
      actionsEmpty: false,
      searchesInProgress: 0,
      realBottom: null,
      isHintInputMessage: false,
      hasLink: false,
      labelTip: null,
      extraTip: null,
      originalVal: null,
      originalNameChanged: false,
      customerTranslationsEnabled: false,
      interfaceTranslationsEnabled: false,
      typingLanguage: null,
      fieldLanguageDb: null,
      translationLabelInfo: $tr("reachInput.translationLabelInfo",
          "Editing a value does not automatically update translations. Go to translations and " +
          "generate correct translations for the updated value."
      ),
      hasChangedValue: false,
    };
  }
}
</script>
